export const NUMBER_SELECTION_TAGS = ['1', '2', '3', '4', '5', '6', 'CB'] as const;
export const LETTER_SELECTION_TAGS = ['A', 'B', 'C', 'D', 'E', 'F', 'G'] as const;
export const SELECTION_BTN_SIZES = ['xl', 'lg', 'sm'] as const;
